import installPwaCta from "./install-pwa-cta.json";
import linkGmailCta from "./link-gmail-cta.json";
import noReceivedInvites from "./no-received-invites.json";
import expandYourNetwork from "./expand-your-network.json";

export default {
  installPwaCta,
  linkGmailCta,
  noReceivedInvites,
  expandYourNetwork,
};
